import React from 'react'

import gasBoilerIconActive from 'src/assets/images/gas-boiler-active.svg'
import gasBoilerIcon from 'src/assets/images/gas-boiler.svg'
import giftIcon from 'src/assets/images/gift.svg'
import homeownerIconActive from 'src/assets/images/homeowner-active.svg'
import homeownerIcon from 'src/assets/images/homeowner.svg'
import adviceIcon from 'src/assets/images/icons/advice.svg'
import arrowDownRed from 'src/assets/images/icons/arrow-down-red.svg'
import arrowDown from 'src/assets/images/icons/arrow-down.svg'
import arrowLeft from 'src/assets/images/icons/arrow-left.svg'
import arrowRight from 'src/assets/images/icons/arrow-right.svg'
import arrowTop from 'src/assets/images/icons/arrow-top.svg'
import chevronDown from 'src/assets/images/icons/chevron-down.svg'
import editIcon from 'src/assets/images/icons/edit.svg'
import errorCircleIcon from 'src/assets/images/icons/error-circle.svg'
import landlordIconActive from 'src/assets/images/landlord-active.svg'
import landlordIcon from 'src/assets/images/landlord.svg'
import lpgBoilerIconActive from 'src/assets/images/lpg-boiler-active.svg'
import lpgBoilerIcon from 'src/assets/images/lpg-boiler.svg'
import morethanoneBoilerIconActive from 'src/assets/images/morethanone-boiler-active.svg'
import morethanoneBoilerIcon from 'src/assets/images/morethanone-boiler.svg'
import oilBoilerIconActive from 'src/assets/images/oil-boiler-active.svg'
import oilBoilerIcon from 'src/assets/images/oil-boiler.svg'
import paperlessIconActive from 'src/assets/images/paperless-active.svg'
import paperlessIcon from 'src/assets/images/paperless.svg'
import postIconActive from 'src/assets/images/post-active.svg'
import postIcon from 'src/assets/images/post.svg'
import tenantIconActive from 'src/assets/images/tenant-active.svg'
import tenantIcon from 'src/assets/images/tenant.svg'

const iconsMap: Record<string, (state?: boolean) => string> = {
  homeowner: (state) => (state ? homeownerIconActive : homeownerIcon),
  landlord: (state) => (state ? landlordIconActive : landlordIcon),
  tenant: (state) => (state ? tenantIconActive : tenantIcon),
  post: (state) => (state ? postIconActive : postIcon),
  paperless: (state) => (state ? paperlessIconActive : paperlessIcon),
  'gas-boiler': (state) => (state ? gasBoilerIconActive : gasBoilerIcon),
  'lpg-boiler': (state) => (state ? lpgBoilerIconActive : lpgBoilerIcon),
  'oil-boiler': (state) => (state ? oilBoilerIconActive : oilBoilerIcon),
  'one-boiler': (state) => (state ? gasBoilerIconActive : gasBoilerIcon),
  'morethanone-boiler': (state) => (state ? morethanoneBoilerIconActive : morethanoneBoilerIcon),
  'error-circle': () => errorCircleIcon,
  'arrow-down': () => arrowDown,
  'arrow-top': () => arrowTop,
  'arrow-down-red': () => arrowDownRed,
  'arrow-left': () => arrowLeft,
  'chevron-down': () => chevronDown,
  //'chevron-down-red': () => chevronDownRed,
  'arrow-right': () => arrowRight,
  'edit': () => editIcon,
  'gift': () => giftIcon,
  'advice': () => adviceIcon
}

const icons = ({ isActive = false, variant }: { isActive?: boolean; variant: string }) => {
  return <img src={iconsMap[variant](isActive)} alt={`icon ${variant}`} />
}

export default icons
